import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { Button } from '@/components/ui/Button'
import { EmptyState } from '@/components/ui/EmptyState'

export function NotFound() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="stage min-h-dvh">
      <div className="rise-in mx-auto flex min-h-dvh max-w-xl items-center p-6">
        <EmptyState
          icon="search"
          title={t('errors.notFoundTitle')}
          description={t('errors.notFoundDescription')}
          className="w-full"
          action={
            <Button
              icon="grid"
              onClick={() => {
                void navigate('/')
              }}
            >
              {t('errors.goHome')}
            </Button>
          }
        />
      </div>
    </div>
  )
}
